export const hiragana = [
  {
    character: "あ",
    romaji: "a",
    sound: "a.mp3",
    color: "hsl(3, 100%, 20%)",
  },
  {
    character: "い",
    romaji: "i",
    sound: "i.mp3",
    color: "hsl(3, 100%, 30%)",
  },
  {
    character: "う",
    romaji: "u",
    sound: "u.mp3",
    color: "hsl(3, 100%, 40%)",
  },
  {
    character: "え",
    romaji: "e",
    sound: "e.mp3",
    color: "hsl(3, 100%, 50%)",
  },
  {
    character: "お",
    romaji: "o",
    sound: "o.mp3",
    color: "hsl(3, 100%, 60%)",
  },
  {
    character: "か",
    romaji: "ka",
    sound: "ka.mp3",
    color: "hsl(221, 100%, 20%)",
  },
  {
    character: "き",
    romaji: "ki",
    sound: "ki.mp3",
    color: "hsl(221, 100%, 30%)",
  },
  {
    character: "く",
    romaji: "ku",
    sound: "ku.mp3",
    color: "hsl(221, 100%, 40%)",
  },
  {
    character: "け",
    romaji: "ke",
    sound: "ke.mp3",
    color: "hsl(221, 100%, 50%)",
  },
  {
    character: "こ",
    romaji: "ko",
    sound: "ko.mp3",
    color: "hsl(221, 100%, 60%)",
  },
  {
    character: "さ",
    romaji: "sa",
    sound: "sa.mp3",
    color: "hsl(147, 100%, 20%)",
  },
  {
    character: "し",
    romaji: "shi",
    sound: "shi.mp3",
    color: "hsl(147, 100%, 30%)",
  },
  {
    character: "す",
    romaji: "su",
    sound: "su.mp3",
    color: "hsl(147, 100%, 40%)",
  },
  {
    character: "せ",
    romaji: "se",
    sound: "se.mp3",
    color: "hsl(147, 100%, 50%)",
  },
  {
    character: "そ",
    romaji: "so",
    sound: "so.mp3",
    color: "hsl(147, 100%, 60%)",
  },
  {
    character: "た",
    romaji: "ta",
    sound: "ta.mp3",
    color: "hsl(181,100%,20%)",
  },
  {
    character: "ち",
    romaji: "chi",
    sound: "chi.mp3",
    color: "hsl(181,100%,30%)",
  },
  {
    character: "つ",
    romaji: "tsu",
    sound: "tsu.mp3",
    color: "hsl(181,100%,40%)",
  },
  {
    character: "て",
    romaji: "te",
    sound: "te.mp3",
    color: "hsl(181,100%,50%)",
  },
  {
    character: "と",
    romaji: "to",
    sound: "to.mp3",
    color: "hsl(181,100%,60%)",
  },
  {
    character: "な",
    romaji: "na",
    sound: "na.mp3",
    color: "hsl(61, 100%, 20%)",
  },
  {
    character: "に",
    romaji: "ni",
    sound: "ni.mp3",
    color: "hsl(61, 100%, 30%)",
  },
  {
    character: "ぬ",
    romaji: "nu",
    sound: "nu.mp3",
    color: "hsl(61, 100%, 40%)",
  },
  {
    character: "ね",
    romaji: "ne",
    sound: "ne.mp3",
    color: "hsl(61, 100%, 50%)",
  },
  {
    character: "の",
    romaji: "no",
    sound: "no.mp3",
    color: "hsl(61, 100%, 60%)",
  },
  {
    character: "は",
    romaji: "ha",
    sound: "ha.mp3",
    color: "hsl(327, 89%, 20%)",
  },
  {
    character: "ひ",
    romaji: "hi",
    sound: "hi.mp3",
    color: "hsl(327, 89%, 30%)",
  },
  {
    character: "ふ",
    romaji: "fu",
    sound: "fu.mp3",
    color: "hsl(327, 89%, 40%)",
  },
  {
    character: "へ",
    romaji: "he",
    sound: "he.mp3",
    color: "hsl(327, 89%, 50%)",
  },
  {
    character: "ほ",
    romaji: "ho",
    sound: "ho.mp3",
    color: "hsl(327, 89%, 60%)",
  },
  {
    character: "ま",
    romaji: "ma",
    sound: "ma.mp3",
    color: "hsl(25, 78%, 20%)",
  },
  {
    character: "み",
    romaji: "mi",
    sound: "mi.mp3",
    color: "hsl(25, 78%, 30%)",
  },
  {
    character: "む",
    romaji: "mu",
    sound: "mu.mp3",
    color: "hsl(25, 78%, 40%)",
  },
  {
    character: "め",
    romaji: "me",
    sound: "me.mp3",
    color: "hsl(25, 78%, 50%)",
  },
  {
    character: "も",
    romaji: "mo",
    sound: "mo.mp3",
    color: "hsl(25, 78%, 60%)",
  },
  {
    character: "や",
    romaji: "ya",
    sound: "ya.mp3",
    color: "hsl(294, 78%, 20%)",
  },
  {
    character: "ゆ",
    romaji: "yu",
    sound: "yu.mp3",
    color: "hsl(294, 78%, 40%)",
  },
  {
    character: "よ",
    romaji: "yo",
    sound: "yo.mp3",
    color: "hsl(294, 78%, 60%)",
  },
  {
    character: "ら",
    romaji: "ra",
    sound: "ra.mp3",
    color: "hsl(96, 100%, 20%)",
  },
  {
    character: "り",
    romaji: "ri",
    sound: "ri.mp3",
    color: "hsl(96, 100%, 30%)",
  },
  {
    character: "る",
    romaji: "ru",
    sound: "ru.mp3",
    color: "hsl(96, 100%, 40%)",
  },
  {
    character: "れ",
    romaji: "re",
    sound: "re.mp3",
    color: "hsl(96, 100%, 50%)",
  },
  {
    character: "ろ",
    romaji: "ro",
    sound: "ro.mp3",
    color: "hsl(96, 100%, 60%)",
  },
  {
    character: "わ",
    romaji: "wa",
    sound: "wa.mp3",
    color: "hsl(249, 50%, 20%)",
  },
  {
    character: "を",
    romaji: "wo",
    sound: "wo.mp3",
    color: "hsl(249, 50%, 60%)",
  },
  {
    character: "ん",
    romaji: "n",
    sound: "n.mp3",
    color: "hsl(0, 50%, 20%)",
  },
];

export const hiragana_divided = [
  {
    letter: "",
    hiragana: hiragana.slice(0, 5),
  },
  {
    letter: "k",
    hiragana: hiragana.slice(5, 10),
  },
  {
    letter: "s",
    hiragana: hiragana.slice(10, 15),
  },
  {
    letter: "t",
    hiragana: hiragana.slice(15, 20),
  },
  {
    letter: "n",
    hiragana: hiragana.slice(20, 25),
  },
  {
    letter: "h",
    hiragana: hiragana.slice(25, 30),
  },
  {
    letter: "m",
    hiragana: hiragana.slice(30, 35),
  },
  {
    letter: "y",
    hiragana: [hiragana[35], {}, hiragana[36], {}, hiragana[37]],
  },
  {
    letter: "r",
    hiragana: hiragana.slice(38, 43),
  },
  {
    letter: "w",
    hiragana: [hiragana[43], {}, {}, {}, hiragana[44]],
  },
  {
    letter: "n",
    hiragana: [hiragana[45], {}, {}, {}, {}],
  },
];
